export type RangeOperator = Extract<
  CrudOperators,
  'between' | 'nbetween' | 'eq' | 'lt' | 'lte' | 'gt' | 'gte'
>;

export const isBinaryRangeOperator = (operator: RangeOperator) =>
  operator === 'between' || operator === 'nbetween';

export type CrudFilter = LogicalFilter | ConditionalFilter;

export type CrudFilters = CrudFilter[];

export type LogicalFilter = {
  field: string;
  operator: Exclude<CrudOperators, 'or' | 'and'>;
  value: any;
};

export type ConditionalFilter = {
  key?: string;
  operator: Extract<CrudOperators, 'or' | 'and'>;
  value: (LogicalFilter | ConditionalFilter)[];
};

export type CrudOperators =
  | 'eq'
  | 'ne'
  | 'eqci'
  | 'neqci'
  | 'lt'
  | 'gt'
  | 'lte'
  | 'gte'
  | 'in'
  | 'nin'
  | 'ina'
  | 'nina'
  | 'inci'
  | 'ninci'
  | 'contains'
  | 'ncontains'
  | 'containss'
  | 'isempty'
  | 'ncontainss'
  | 'between'
  | 'nbetween'
  | 'null'
  | 'nnull'
  | 'startswith'
  | 'nstartswith'
  | 'startswiths'
  | 'nstartswiths'
  | 'endswith'
  | 'nendswith'
  | 'endswiths'
  | 'nendswiths'
  | 'or'
  | 'and';
